<template>
  <div>
    <form @submit.prevent="submit">
      <v-row>
        <v-col>
          <SGPFormInputComponent type="text" :name="'numero_rec'" v-model="formulario.numero_rec"
            :placeholder="labelNumeroRec" :data-vv-as="labelNumeroRec" v-validate="'required|min:3|max:50'"
            :error="validationErrors.first('numero_rec')" />
        </v-col>

        <v-col>
          <SGPFormInputComponent type="text" :name="'numero_protocolo'" v-model="formulario.numero_protocolo"
            :placeholder="labelNumeroProtocolo" :data-vv-as="labelNumeroProtocolo" v-validate="'required|min:3|max:50'"
            :error="validationErrors.first('numero_protocolo')" />
        </v-col>

        <v-col>
          <SGPFormInputComponent type="text" :name="'cliente_final'" v-model="formulario.cliente_final"
            placeholder="Cliente Final" data-vv-as="Cliente Final" v-validate="'required|min:3|max:50'"
            :error="validationErrors.first('cliente_final')" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <SGPFormAutocompleteComponent :name="'designacao_claro'" :listaDeOptions="listaDeDesignacao"
            v-model="formulario.designacao_claro" :optionLabel="'designacao'" :optionValue="'id'" :editar="true" :criar="true"
            :changeText="changeTextCriar"
            :placeholder="`${labelDesignacaoClaro} (digite pelo menos 3 letras)`" :data-vv-as="labelDesignacaoClaro"
            v-validate="'required'" :error="validationErrors.first('designacao_claro')"
            :loading="loadingDesignacao || carregandoDesignacoes" @update:search-input="buscarDesignacoes"
            @input="setDesignacaoSelecionada" @editarSelecionado="onEditarDesignacao"
            @criarSelecionado="onCriarDesignacao" />
        </v-col>

        <v-col>
          <SGPFormInputComponent type="text" :name="'acesso_lp'" id="acesso_lp" :disabled="acessoLpDesabilitado"
            v-model="formulario.acesso_lp" :placeholder="labelDesignacaoProvedor" :data-vv-as="labelDesignacaoProvedor"
            v-validate="'required|min:3|max:50'" :error="validationErrors.first('acesso_lp')" />
        </v-col>

        <v-col>
          <SGPFormSelectComponent :name="'ctrl_provedor_id'" :listaDeOptions="listaDeProvedores"
            v-model="formulario.ctrl_provedor_id" :optionLabel="'nome'" :placeholder="labelProvedor" :data-vv-as="labelProvedor"
            v-validate="'required'" :error="validationErrors.first('ctrl_provedor_id')" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <SGPFormSelectComponent :name="'ctrl_workflow_id'" :listaDeOptions="listaDeWorkflows"
            v-model="formulario.ctrl_workflow_id" :optionLabel="'workflow'" :placeholder="labelWorkflow" :data-vv-as="labelWorkflow"
            v-validate="'required'" :error="validationErrors.first('ctrl_workflow_id')" />
        </v-col>

        <v-col>
          <SGPFormInputComponent type="text" :name="'identificacao_acesso_provedor'"
            v-model="formulario.identificacao_acesso_provedor" :placeholder="labelIdentificacaoAcessoProvedor"
            :data-vv-as="labelIdentificacaoAcessoProvedor" v-validate="'max:255'"
            :error="validationErrors.first('identificacao_acesso_provedor')" />
        </v-col>

        <v-col>
          <SGPFormInputComponent type="text" :name="'area_tecnica'"
            v-model="formulario.area_tecnica" placeholder="Área Técnica"
            data-vv-as="Área Técnica" v-validate="'max:255'"
            :error="validationErrors.first('area_tecnica')" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <SGPFormInputComponent :name="'descricao_problema'" v-model="formulario.descricao_problema"
            placeholder="Descrição do Problema" data-vv-as="Descrição do Problema" v-validate="'required|min:3'"
            :error="validationErrors.first('descricao_problema')" />
        </v-col>

        <v-col>
          <SGPFormInputComponent :name="'observacoes'" v-model="formulario.observacoes"
             placeholder="Observações" data-vv-as="Observações" v-validate="'required|min:3'"
             :error="validationErrors.first('observacoes')" />
        </v-col>
      </v-row>

      <!-- <v-row>
        <v-col>
          <SGPFormInputComponent type="date" :name="'data_atendimento_cliente'"
            v-model="formulario.data_atendimento_cliente" placeholder="Data Atendimento Cliente"
            data-vv-as="Data de Atendimento" v-validate="'required|after_or_equal_today'"
            :error="validationErrors.first('data_atendimento_cliente')" />
        </v-col>

        <v-col>
          <SGPFormInputComponent type="date" :name="'data_agendamento'" v-model="formulario.data_agendamento"
            placeholder="Data de Agendamento" data-vv-as="Data de Agendamento"
            v-validate="'required|after_or_equal_today'" :error="validationErrors.first('data_agendamento')" />
        </v-col>
      </v-row> -->

      <v-row>
        <v-col>
          <div class="container-botoes">
            <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
              type="submit">
              {{ tipoFormulario === 'salvar' ? 'Abrir Ticket' : 'Atualizar Ticket' }}
            </button>

            <button
              class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
              type="button" @click="fecharModal">
              Cancelar
            </button>
          </div>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { rotuloTelmex } from '@/common/helpers/ProvedorTelmex';

export default {
  name: "FormularioTicketComponent",
  props: {
    tipoFormulario: {
      type: String,
      default: 'salvar'
    },
    ticket: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      formulario: {
        ...(this.ticket || {
          numero_rec: '',
          numero_protocolo: '',
          cliente_final: '',
          designacao_claro: '',
          acesso_lp: '',
          ctrl_provedor_id: '',
          ctrl_workflow_id: '',
          identificacao_acesso_provedor: '',
          descricao_problema: '',
          data_abertura_ticket: '',
        }),
        area_tecnica: this.ticket?.area_tecnica || '',
      },
      carregandoDesignacoes: false,
      timeoutBusca: null,
      changeTextCriar: 'Criar Designação',
    }
  },
  created() {
    this.listarProvedores();
    this.listarWorkflows();
  },
  computed: {
    ...mapGetters('ctrlWorkflow', ['listaDeWorkflows']),
    ...mapGetters('ctrlProvedores', ['listaDeProvedores']),
    ...mapGetters('ctrlDesignacao', ['listaDeDesignacao', 'loadingDesignacao', 'atualizarDesignacao']),
    ...mapGetters('login', ['isProvedorTelmex']),

    acessoLpDesabilitado() {
      return !this.formulario.designacao_claro;
    },

    labelNumeroRec() {
      return rotuloTelmex('numero_rec', 'Número REC', this.isProvedorTelmex);
    },

    labelNumeroProtocolo() {
      return rotuloTelmex('numero_protocolo', 'Protocolo Provedor', this.isProvedorTelmex);
    },

    labelDesignacaoClaro() {
      return rotuloTelmex('designacao_claro', 'Designação Claro', this.isProvedorTelmex);
    },

    labelDesignacaoProvedor() {
      return rotuloTelmex('acesso_lp', 'Designação provedor', this.isProvedorTelmex);
    },

    labelProvedor() {
      return rotuloTelmex('ctrl_provedor_id', 'Provedor', this.isProvedorTelmex);
    },

    labelIdentificacaoAcessoProvedor() {
      return rotuloTelmex('identificacao_acesso_provedor', 'Identificação de Acesso Provedor', this.isProvedorTelmex);
    },

    labelWorkflow() {
      return rotuloTelmex('ctrl_workflow_id', 'Workflow', this.isProvedorTelmex);
    },
  },
  watch: {
    // 'formulario.designacao_claro': {
    //   immediate: true,
    //   handler(valorSelecionado) {
    //     this.setDesignacaoSelecionada(valorSelecionado);
    //   }
    // },

    listaDeDesignacao() {
      if (this.formulario.designacao_claro) {
        this.setDesignacaoSelecionada(this.formulario.designacao_claro);
      }
    }
  },
  methods: {
    ...mapActions('tickets', ['abrirTicket', 'atualizarTicket']),
    ...mapActions('ctrlWorkflow', ['listarWorkflows']),
    ...mapActions('ctrlProvedores', ['listarProvedores']),
    ...mapActions('ctrlDesignacao', ['listarDesignacao']),

    buscarDesignacoes(termo) {
      if (this.timeoutBusca) {
        clearTimeout(this.timeoutBusca);
      }

      if (!termo || termo.length < 3) {
        return;
      }

      this.timeoutBusca = setTimeout(async () => {
        this.carregandoDesignacoes = true;
        try {
          await this.listarDesignacao({
            page: 1,
            current_page: 1,
            per_page: 50,
            designacao: termo
          });
        } catch (error) {
          console.error('Erro ao buscar designações:', error);
        } finally {
          this.carregandoDesignacoes = false;
        }
      }, 300);
    },

    onEditarDesignacao(designacao) {
      this.$emit('editarDesignacao', designacao);
    },

    onCriarDesignacao() {
      this.$emit('criarDesignacao');
    },

    async setDesignacaoSelecionada(designacao) {
      if (!designacao) {
        this.formulario.acesso_lp = '';
        return;
      }

      if (typeof designacao === 'object' && designacao.id) {
        this.carregandoDesignacoes = true;
        try {
          await this.listarDesignacao({
            page: 1,
            current_page: 1,
            per_page: 50,
            designacao: designacao.designacao,
          });
        } finally {
          this.carregandoDesignacoes = false;
        }

        this.formulario.designacao_claro = designacao.id;
        this.formulario.acesso_lp = designacao.acesso_lp || '';
        return;
      }

      const designacaoSelecionada = this.listaDeDesignacao.find(
        d => String(d.id) === String(designacao)
      );

      if (designacaoSelecionada) {
        this.formulario.acesso_lp = designacaoSelecionada.acesso_lp || '';
      }
    },

    limparCampos() {
      Object.keys(this.formulario).forEach(k => (this.formulario[k] = ''));
      this.$validator.reset();
    },

    montarPayload() {
      const payload = { ...this.formulario }
      delete payload.centro_funcional

      const areaTecnica = String(payload.area_tecnica || '').trim()
      if (areaTecnica) {
        payload.area_tecnica = areaTecnica
      } else {
        delete payload.area_tecnica
      }

      return payload
    },

    async submit() {
      const valido = await this.$validator.validateAll();
      if (!valido) return;

      const acao = this.tipoFormulario === 'salvar'
        ? this.abrirTicket
        : this.atualizarTicket;

      const resp = await acao(this.montarPayload());
      if (!resp) return;

      if (resp.pco_workflow?.tarefas?.length > 0) {

        const primeiraTarefa = resp.pco_workflow.tarefas[0];

        this.$router.push({
          name: 'ficha-tecnica-tarefa',
          params: { pco_tarefa_id: primeiraTarefa.id }
        });
      }

      this.limparCampos();
      // this.fecharModal();
    },

    fecharModal() {
      this.$parent.$parent.$parent.$parent.fecharModal();
    }
  }
};
</script>
